import { render } from "./user-panel.vue?vue&type=template&id=8812934a&scoped=true"
import script from "./user-panel.vue?vue&type=script&lang=js"
export * from "./user-panel.vue?vue&type=script&lang=js"

import "./user-panel.vue?vue&type=style&index=0&id=8812934a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8812934a"]])

export default __exports__